import { render, staticRenderFns } from "./PurScI_List.vue?vue&type=template&id=2b460668"
import script from "./PurScI_List.vue?vue&type=script&lang=js"
export * from "./PurScI_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports